import { Theme } from '@mui/material/styles';

import { menuItem } from '../../css';

// ----------------------------------------------------------------------

export function menu(theme: Theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          padding: '0 !important',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          ...menuItem(theme)
        },
      },
    },
  };
}
